module.exports = __webpack_public_path__ + "img/5.61560d0.jpg";